import { registryApi } from '../clients/AxiosClients'

/**
 * Retorna todos os tipos de servicos possiveis para importacao de medicao de CSV
 * cadastradas no banco de dados
 */
const getAllTiposDeServicos = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/TipoDeServico')
	return result
		.filter(
			(tipoDeServico) =>
				tipoDeServico.tpsv_cd_codigo === '001' ||
				tipoDeServico.tpsv_cd_codigo === '002' ||
				tipoDeServico.tpsv_cd_codigo === '003' ||
				tipoDeServico.tpsv_cd_codigo === '005' ||
				tipoDeServico.tpsv_cd_codigo === '007' ||
				tipoDeServico.tpsv_cd_codigo === '008' ||
				tipoDeServico.tpsv_cd_codigo === '009',
		)
		.map((tipoDeServico) => {
			return {
				label: `${tipoDeServico.tpsv_cd_codigo} - ${tipoDeServico.tpsv_ds_descricao}`,
				value: tipoDeServico.id,
			}
		})
}

/**
 * Retorna todos os tipos de servicos possiveis para importacao de medicao de CSV
 * cadastradas no banco de dados
 */
const getTipoDeServicoCSVDropdown = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/TipoDeServico')
	return result
		.filter(
			(tipoDeServico) =>
				tipoDeServico.tpsv_cd_codigo === '001' ||
				tipoDeServico.tpsv_cd_codigo === '002' ||
				tipoDeServico.tpsv_cd_codigo === '003' ||
				tipoDeServico.tpsv_cd_codigo === '019',
		)
		.map((tipoDeServico) => {
			return {
				label: `${tipoDeServico.tpsv_cd_codigo} - ${tipoDeServico.tpsv_ds_descricao}`,
				value: tipoDeServico.id,
			}
		})
}

export { getAllTiposDeServicos, getTipoDeServicoCSVDropdown }
